import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import Footer from "../components/Footer";

export default function LegalPlaceholder({ title, intro, lastUpdated }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="legal-page">
      <header className="sticky top-0 z-40 jn-glass-strong">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/">
            <Logo size="text-xl" />
          </Link>
          <Link
            to="/"
            className="jn-btn-ghost px-4 py-2 rounded-full text-xs inline-flex items-center gap-2"
          >
            <ArrowLeft size={14} /> Terug naar home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-5">
          Juridisch
        </div>
        <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight">
          {title}
        </h1>
        <p className="mt-4 text-sm text-zinc-500 font-body">
          Laatst bijgewerkt: {lastUpdated}
        </p>

        <div className="mt-12 space-y-6 font-body text-zinc-300 leading-relaxed">
          {intro}
          <div className="jn-glass rounded-2xl p-6 mt-8">
            <p className="text-sm text-zinc-400">
              De volledige tekst van dit document wordt binnenkort
              gepubliceerd. Heb je nu al een specifieke vraag? Neem dan contact
              op via{" "}
              <a
                href="mailto:info@jynova.be"
                className="text-cyan-400 hover:underline"
              >
                info@jynova.be
              </a>
              .
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
